module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "orderNum",
      "label": _vm.$t('order.code'),
      "rules": [{
        required: true,
        message: 'Please input order code',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.orderNum),
      callback: function($$v) {
        _vm.form.orderNum = $$v
      },
      expression: "form.orderNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "billNumber",
      "label": _vm.$t('order.billNumber')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.billNumber),
      callback: function($$v) {
        _vm.form.billNumber = $$v
      },
      expression: "form.billNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "orderDate",
      "label": _vm.$t('order.orderDate'),
      "rules": [{
        required: true,
        message: 'Please select order date'
      }]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('order.orderDatePlaceholder')
    },
    model: {
      value: (_vm.form.orderDate),
      callback: function($$v) {
        _vm.form.orderDate = $$v
      },
      expression: "form.orderDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customerName",
      "label": _vm.$t('customer.name'),
      "rules": [{
        required: true,
        message: 'Please input customer name'
      }]
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "autosize": "",
      "fetch-suggestions": _vm.customerSearch,
      "placeholder": _vm.$t('customer.namePlaceholder')
    },
    on: {
      "select": _vm.handleCustomerSelect
    },
    model: {
      value: (_vm.form.customerName),
      callback: function($$v) {
        _vm.form.customerName = $$v
      },
      expression: "form.customerName"
    }
  }), _vm._v("\n         \n        "), (_vm.form.customerId) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetCustomer()
      }
    }
  }, [_vm._v("ลบข้อมูลลูกค้า")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "customerPhoneNumber",
      "label": _vm.$t('customer.phoneNumber'),
      "rules": [{
        type: 'string',
        min: 9,
        max: 10,
        message: 'Please input a valid phone number',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.customerPhoneNumber),
      callback: function($$v) {
        _vm.form.customerPhoneNumber = $$v
      },
      expression: "form.customerPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "customerLineId",
      "label": _vm.$t('customer.lineId')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.customerLineId),
      callback: function($$v) {
        _vm.form.customerLineId = $$v
      },
      expression: "form.customerLineId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', {
    staticClass: "form-header"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('order.deliveryDetail')) + "\n      ")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "deliveryType",
      "label": _vm.$t('order.deliveryType'),
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('order.deliveryTypePlaceholder')
    },
    on: {
      "change": _vm.handleDeliveryTypeSelect
    },
    model: {
      value: (_vm.form.deliveryType),
      callback: function($$v) {
        _vm.form.deliveryType = $$v
      },
      expression: "form.deliveryType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "มารับสินค้าเอง",
      "value": "pickUp"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "บริการจัดส่ง",
      "value": "mailDelivery"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "บริการเซ็ทอัพ",
      "value": "setup"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryName",
      "label": _vm.$t('order.deliveryName')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.deliveryName),
      callback: function($$v) {
        _vm.form.deliveryName = $$v
      },
      expression: "form.deliveryName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.form.deliveryType === 'setup') ? _c('el-form-item', {
    attrs: {
      "prop": "setupPrice",
      "label": _vm.$t('order.setupPrice'),
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.setupPrice),
      callback: function($$v) {
        _vm.form.setupPrice = $$v
      },
      expression: "form.setupPrice"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryPrice",
      "label": _vm.$t('order.deliveryPrice'),
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.deliveryPrice),
      callback: function($$v) {
        _vm.form.deliveryPrice = $$v
      },
      expression: "form.deliveryPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryTime",
      "label": _vm.$t('order.deliveryTime')
    }
  }, [_c('el-time-select', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "เลือกช่วงเวลา",
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '22:00'
      }
    },
    model: {
      value: (_vm.form.deliveryTime[0]),
      callback: function($$v) {
        var $$exp = _vm.form.deliveryTime,
          $$idx = 0;
        if (!Array.isArray($$exp)) {
          _vm.form.deliveryTime[0] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "form.deliveryTime[0]"
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "format": "HH:mm",
      "placeholder": "เลือกช่วงเวลา",
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '22:00',
        minTime: _vm.form.deliveryTime[0]
      }
    },
    model: {
      value: (_vm.form.deliveryTime[1]),
      callback: function($$v) {
        var $$exp = _vm.form.deliveryTime,
          $$idx = 1;
        if (!Array.isArray($$exp)) {
          _vm.form.deliveryTime[1] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "form.deliveryTime[1]"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.form.deliveryType === 'mailDelivery' || _vm.form.deliveryType === 'setup') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "deliveryPlaceName",
      "label": _vm.$t('order.deliveryPlaceName')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.deliveryPlaceName),
      callback: function($$v) {
        _vm.form.deliveryPlaceName = $$v
      },
      expression: "form.deliveryPlaceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryAddress",
      "label": _vm.$t('order.address')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.deliveryAddress),
      callback: function($$v) {
        _vm.form.deliveryAddress = $$v
      },
      expression: "form.deliveryAddress"
    }
  }), _vm._v(" "), _c('address-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addresses),
      expression: "addresses"
    }],
    attrs: {
      "addresses": _vm.addresses
    },
    on: {
      "insert": _vm.replaceAddress
    }
  }), _vm._v(" "), _c('wordboard', {
    on: {
      "insert": _vm.addToAddress
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "deliveryPhoneNumber",
      "label": _vm.$t('order.receiverPhoneNumber')
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.deliveryPhoneNumber),
      callback: function($$v) {
        _vm.form.deliveryPhoneNumber = $$v
      },
      expression: "form.deliveryPhoneNumber"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "deliveryDate",
      "label": _vm.$t('order.deliveryDate'),
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.form.deliveryDate),
      callback: function($$v) {
        _vm.form.deliveryDate = $$v
      },
      expression: "form.deliveryDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": _vm.$t('order.remark')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.form.remark = $$v
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', {
    staticClass: "form-header"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('order.productDetail')) + "\n      ")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24,
      "gutter": 20
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#",
      "width": "90"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n            "), (_vm.form.items.length > 1) ? _c('icon', {
          staticStyle: {
            "display": "inline-block",
            "position": "relative",
            "top": "2px"
          },
          attrs: {
            "fill": "#c1d6ef",
            "name": "angle-up"
          },
          nativeOn: {
            "click": function($event) {
              _vm.moveUp(scope.$index)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.form.items.length > 1) ? _c('icon', {
          staticStyle: {
            "display": "inline-block",
            "position": "relative",
            "top": "2px"
          },
          attrs: {
            "fill": "#c1d6ef",
            "name": "angle-down"
          },
          nativeOn: {
            "click": function($event) {
              _vm.moveDown(scope.$index)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.form.items.length !== 1) ? _c('icon', {
          staticStyle: {
            "display": "inline-block",
            "position": "relative",
            "top": "2px"
          },
          attrs: {
            "fill": "#c1d6ef",
            "name": "close"
          },
          nativeOn: {
            "click": function($event) {
              _vm.removeItem(scope.$index)
            }
          }
        }) : _vm._e()]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refCode",
      "label": _vm.$t('product.refCode')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-select', {
          attrs: {
            "loading": _vm.productLoading,
            "placeholder": _vm.$t('order.productRefCodePlaceholder'),
            "filterable": "",
            "remote": "",
            "remote-method": _vm.productSearch
          },
          on: {
            "change": function($event) {
              _vm.handleProductSelect(scope.$index)
            }
          },
          model: {
            value: (_vm.form.items[scope.$index].refCode),
            callback: function($$v) {
              _vm.form.items[scope.$index].refCode = $$v
            },
            expression: "form.items[scope.$index].refCode"
          }
        }, _vm._l((_vm.products), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.refCode,
              "value": item.value
            }
          })
        }))]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "width": "250",
      "label": _vm.$t('product.name')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('div', {
          staticStyle: {
            "padding": "5px"
          }
        }, [_c('el-input', {
          staticStyle: {
            "display": "inline"
          },
          model: {
            value: (_vm.form.items[scope.$index].title),
            callback: function($$v) {
              _vm.form.items[scope.$index].title = $$v
            },
            expression: "form.items[scope.$index].title"
          }
        })], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('div', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              _vm.openExtraEdit(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit",
          staticStyle: {
            "display": "inline"
          }
        })])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "prop": "quantity",
      "label": _vm.$t('product.quantity')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-input', {
          attrs: {
            "min": "1",
            "type": "number"
          },
          model: {
            value: (_vm.form.items[scope.$index].quantity),
            callback: function($$v) {
              _vm.form.items[scope.$index].quantity = $$v
            },
            expression: "form.items[scope.$index].quantity"
          }
        })]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "prop": "discountable",
      "label": _vm.$t('product.discountableShort')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (_vm.form.items[scope.$index].discountable),
            callback: function($$v) {
              _vm.form.items[scope.$index].discountable = $$v
            },
            expression: "form.items[scope.$index].discountable"
          }
        })]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": _vm.$t('product.price')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: (_vm.form.items[scope.$index].price),
            callback: function($$v) {
              _vm.form.items[scope.$index].price = $$v
            },
            expression: "form.items[scope.$index].price"
          }
        })]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalPrice",
      "label": _vm.$t('product.totalPrice')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n            ฿ " + _vm._s(_vm.form.items[scope.$index].totalPrice) + "\n          ")]
      }]
    ])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addOrderItem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('order.addMoreProduct')))])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('product.images')
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.imageActionURL,
      "headers": _vm.imageHeaders,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "file-list": _vm.fileList,
      "on-success": _vm.handleImageUploaded,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.imgDialog),
      callback: function($$v) {
        _vm.imgDialog = $$v
      },
      expression: "imgDialog"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImgUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('order.tax')
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.form.tax, '฿')) + " (\n        "), _c('el-checkbox', {
    model: {
      value: (_vm.form.bypassTax),
      callback: function($$v) {
        _vm.form.bypassTax = $$v
      },
      expression: "form.bypassTax"
    }
  }, [_vm._v("ยกเว้นภาษี")]), _vm._v(")\n      ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "discount",
      "label": _vm.$t('order.discount'),
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.form.discount = $$v
      },
      expression: "form.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('order.totalPrice')
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.form.totalPrice, '฿')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Extra Description",
      "visible": _vm.extraDialogVisible,
      "size": "tiny",
      "before-close": _vm.handleClose
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.curExtra),
      callback: function($$v) {
        _vm.curExtra = $$v
      },
      expression: "curExtra"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setExtra()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('order.setExtra')))])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('hr', {
    staticClass: "hrFade"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('hr', {
    staticClass: "hrFade"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0308e3"}!./src/components/orderForm/orderForm.html
// module id = 801
// module chunks = 1